import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { Link } from '../../../api/models/link';
import { ApiErrorCode, ServiceURLConstants } from '../../../constants/upplm.constants';
import { LANGUAGES_COUNTRIES_LOCALES } from '../../../constants/upplm.constants.dashboard';
import { MESSAGE_BY_STATUS, PLACARD_STATUS } from '../../../constants/upplm.constants.qvdashboard';
import { ExcelColumns } from '../../../interface/file-export.interface';
import { File } from '../../../interface/file.interface.interface';
import { QVListResponse } from '../../../interface/upplm.qvList';
import { Column } from '../../../interface/upplm.qvSummaries';
import { TranslateDataPipe } from '../../../pipes/translation.pipe';
import { UpplmApiService } from '../../../services/upplm.api.services';
import { UpsCommonService } from '../../../services/upplm.common.service';
import { QVDashboardSearchService } from '../../../services/upplm.qvDashboardSearch.service';
import { UpsDialogComponent } from '../../commonComponent/ups-dialog/ups-dialog.component';
import { UpsExportFileComponent } from '../../commonComponent/ups-export-file/ups-export-file.component';
import { UpsHamMenuComponent } from '../../commonComponent/ups-ham-menu/ups-ham-menu.component';
import { WindowResize } from '../../commonComponent/ups-resize-window/screen-size.';

const SEND_EMAIL = 1;
const DOWNLOAD_FILE = 2;

declare var $: any;

@Component({
    selector: 'qvsummary-list',
    template: require('./qvsummary-list.component.html'),
    providers: [DatePipe]

})
/** qvsummary-list component*/
export class QvsummaryListComponent implements OnDestroy {

    public myQVListResponse: QVListResponse;
    public linksForCountry: Link[] = [];
    public localeCountry: string = '';

    //Ham menu 
    @ViewChild('actionMenu', { static: false })
    public actionMenu: UpsHamMenuComponent;

    @ViewChild('actionMenuExportFile', { static: false })
    public actionMenuExportFile: UpsExportFileComponent;

    @ViewChild('succesModal', { static: false }) succesModal: UpsDialogComponent;

    public isCancelled: boolean = false;
    public urlTemporary: string = '';

    //head columns list
    public columns: Column[] = [
        { columnIndex: 0, field: 'actions', text: this._translateData.transform('upplm.listview.actions'), width: 100, dataminwidth: 100, resizeButtonLimit: 0, allowSort: false, ascSort: false, descSort: false, resizeButtonActive: false },
        { columnIndex: 1, field: 'placardID', text: this._translateData.transform('upplm.common.placardid'), width: 250, dataminwidth: 200, resizeButtonLimit: 350, allowSort: true, ascSort: false, descSort: false, resizeButtonActive: true },
        { columnIndex: 2, field: 'placardStatus', text: this._translateData.transform('upplm.common.status'), width: 380, dataminwidth: 250, resizeButtonLimit: 730, allowSort: true, ascSort: false, descSort: false, resizeButtonActive: true },
        { columnIndex: 3, field: 'pickupStartDate', text: this._translateData.transform('upplm.common.pickupstartdate'), width: 250, dataminwidth: 200, resizeButtonLimit: 980, allowSort: true, ascSort: false, descSort: false, resizeButtonActive: true },
        { columnIndex: 4, field: 'companyName', text: this._translateData.transform('upplm.common.companyname'), width: 250, dataminwidth: 250, resizeButtonLimit: 1230, allowSort: false, ascSort: false, descSort: false, resizeButtonActive: true },
        { columnIndex: 5, field: 'address', text: this._translateData.transform('upplm.common.address'), width: 250, dataminwidth: 250, resizeButtonLimit: 1480, allowSort: false, ascSort: false, descSort: false, resizeButtonActive: true },
        { columnIndex: 6, field: 'clientNickname', text: this._translateData.transform('upplm.common.clientkeynicknames'), width: 250, dataminwidth: 200, resizeButtonLimit: 1730, allowSort: true, ascSort: false, descSort: false, resizeButtonActive: true }
    ];

    @Output() totalListPlacards = new EventEmitter<number>();
    @Output() messageStatus = new EventEmitter<string[]>();
    @Output() placardIdDetail = new EventEmitter<string>();
    @Input() cardStatus: string = '';
    placardsCount: number = 0;
    optionSelectedDropdown: string = '';
    optionSelectedInput: string = '';
    public supportPhoneNumber: string = '';
    public ListAndAccordeon: boolean = false;
    private windowResize: WindowResize;
    public toggleButtonExport: boolean = false;
    public isLoadingFileExport: boolean = false;
    public isLoading: boolean = true;
    public validateSizeMaxFile: boolean = false;
    subscription: Subscription = new Subscription();
    temporaryPlacardLinks: Link[] = [];


    /** qvsummary-list ctor */
    constructor(private _commonService: UpsCommonService,
        private _apiService: UpplmApiService,
        private qvDashboardSearchService: QVDashboardSearchService,
        private datePipe: DatePipe,
        private _translateData: TranslateDataPipe
    ) { }

    ngOnInit() {
        this.localeCountry = this._commonService.locale_country;
        this.getAllResults();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public resizeWindow(event: WindowResize) {
        this.ListAndAccordeon = false;
        this.windowResize = new WindowResize();
        this.windowResize = event;
        if (this.windowResize.sizeBootStrap === 'xs' || this.windowResize.sizeBootStrap === 'sm' || this.windowResize.sizeBootStrap === 'md') {
            this.ListAndAccordeon = true;
        } else {
            this.ListAndAccordeon = false;
        }
    }

    public resizeTable(event: any) {
        this.columns = event;
    }

    // =====================================================================================================================
    //  Actions Menus
    // =====================================================================================================================

    public actionMenuHam(element: HTMLButtonElement, url: string, placardId: string) {
        this.urlTemporary = url.replace("{placardID}", placardId);
        this.temporaryPlacardLinks = this.prepareLinksForTemporaryPlacard(placardId);
        this.actionMenu.show(element);
    }

    public actionExportFileMenu(element: HTMLButtonElement) {
        this.toggleButtonExport = !this.toggleButtonExport;
        this.actionMenuExportFile.show(element);
    }

    // =====================================================================================================================
    // Export Excel or Send Email
    // =====================================================================================================================

    public sendMailOrDownload(event: any): void {
        this.toggleButtonExport = false;
        let sendOrDownloadFile: number = event.EmailDownloadValue;
        let requestList: Array<any> = [];
        this.isLoadingFileExport = this.isLoadingFile(sendOrDownloadFile);
        this.myQVListResponse.locations.forEach(item => {
            let excelColumns: ExcelColumns = new ExcelColumns();
            excelColumns.placardId = item.placardId;
            excelColumns.status = this.getStatus(item.placardStatus, item.lastPlacardUpdate);
            excelColumns.pickupStartDate = item.pickupStartDate;
            excelColumns.address = this.getAddressForExportFile(item.address);
            excelColumns.clientKey = item.clientKeys[0].nickname;
            excelColumns.companyName = item.companyName;
            requestList.push(excelColumns);
        });

        let request: any = {
            emailDownloadValue: event.EmailDownloadValue,
            excelFormat: event.excelFormat,
            fileListRequest: {
                recipient: event.email,
                locale: this._commonService.locale,
                listView: requestList
            }
        }

        let url = this._commonService.createURL(ServiceURLConstants.GET_FILE_EXCEL_OR_EMAIL, ApiErrorCode.GET_QVSUMMARIES);
        const subscription$ = this._apiService.PostServiceAPI(url, request).
            subscribe((response: any) => {
                this.isLoadingFileExport = false;
                let file: File = response;
                if (!file.errors) {

                    if (file.resultSizeMax === 'longSize') {
                        this.setValidationOptions(true, true);
                    } else {
                        this.setValidationOptions(false, false);
                        this.actionDownloadFile(file.resultSizeMax, sendOrDownloadFile, file);
                    }
                    if (file.emailSend === 'ok') {
                        if (sendOrDownloadFile === SEND_EMAIL) {
                            this.openModel();
                        }
                    }
                }
            });

        this.subscription.add(subscription$);
    }

    getStatus(crisStatus: string, lastPlacardUpdate: string = ''): string {
        switch (crisStatus) {
            case PLACARD_STATUS.DISPATCHED:
                return this._translateData.transform('upplm.common.ready');
            case PLACARD_STATUS.PAUSED:
                return this._translateData.transform('upplm.common.pickupspaused');
            case PLACARD_STATUS.CREATED_2:
            case PLACARD_STATUS.ACTIVE:
            case PLACARD_STATUS.PENDING:
                return this._translateData.transform('upplm.common.awaitingapproval');
            case PLACARD_STATUS.CANCELLED:
                return `${this._translateData.transform('upplm.listview.cancelledon')} '${this.datePipe.transform(lastPlacardUpdate, 'MM/dd/yyyy').toString()}`;
            case PLACARD_STATUS.CREATED_1:
                return this._translateData.transform('upplm.common.created');
            case PLACARD_STATUS.REJECTED:
            case PLACARD_STATUS.AGED:
            case PLACARD_STATUS.EXPIRED_2:
                return this._translateData.transform('upplm.common.firstpickupdatedelayed');
            case PLACARD_STATUS.EXPIRED_1:
                return this._translateData.transform('upplm.common.expired');
            default:
                return '';
        }
    }

    isLoadingFile(selectedOption: number): boolean {
        if (selectedOption === DOWNLOAD_FILE) {
            return true;
        }
        return false;
    }

    setValidationOptions(validateSizeMaxFile: boolean, validationDownloadSize: boolean): void {
        this.validateSizeMaxFile = validateSizeMaxFile;
        this.actionMenuExportFile.validationDownloadSize(validationDownloadSize);
    }

    actionDownloadFile(resultSizeMax: string, sendOrDownloadFile: number, file: File): void {
        if (resultSizeMax === 'ok' && sendOrDownloadFile === DOWNLOAD_FILE) {
            this.actionMenuExportFile.hide();
            this.downloadFile(file);
        } else {
            return;
        }
    }

    public actionClickOutMenuExportFile(event: any): void {
        if (event) {
            this.toggleButtonExport = false;
        }
    }

    // =====================================================================================================================
    // Download of file
    // =====================================================================================================================

    private downloadFile(file: any): void {
        let blob = new Blob([this.base64ToArrayBuffer(file.fileContent)], { type: 'application/octet-stream' });
        let fileData = URL.createObjectURL(blob);
        let a = window.document.createElement('a');
        a.href = fileData;
        a.download = file.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    private base64ToArrayBuffer(base64: string): any {
        let binaryString = window.atob(base64);
        let length = binaryString.length;
        let bytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    // =====================================================================================================================
    // Modal
    // =====================================================================================================================

    public openModel() {
        this.succesModal.open();
    }

    public closeModal() {
        this.actionMenuExportFile.hide();
        this.succesModal.close();
    }

    getTotalListPlacards() {
        this.totalListPlacards.emit(this.placardsCount);
    }

    getMessageByStatus() {
        const dataToPass: string[] = [];

        dataToPass[0] = this.placardsCount.toString();
        if (this.cardStatus !== '') {
            dataToPass[1] = this._translateData.transform(MESSAGE_BY_STATUS.filter(est => est.status === this.cardStatus)[0].translationKey);
            this.isCancelled = this.cardStatus === "Cancelled" ? true : false;
        } else {
            dataToPass[1] = this._translateData.transform('upplm.common.totalplacards');
        }
        this.messageStatus.emit(dataToPass);
    }

    public sort(fieldId: string) {
        if (fieldId) {
            this.columns.forEach(column => {
                if (column.allowSort) {
                    if (column.field === fieldId) {// Required sort on this column
                        this.getColumnSortingValue(column);
                    } else { // No required sort on this column
                        column.ascSort = false;
                        column.descSort = false;
                    }
                }
            });
            let requiredColumn: Column = this.columns.filter(c => c.field === fieldId)[0];
            this.qvDashboardSearchService.qvSearchRequest.sort = requiredColumn.ascSort ? '+' : '-';
            this.qvDashboardSearchService.qvSearchRequest.sort += fieldId;
            this.getAllResults();
        }
    }

    getColumnSortingValue(column: Column): Column {
        if (!column.ascSort && !column.descSort) {// No previous sort on this column
            column.ascSort = true;
        }
        else {// Toggle sort on this column
            column.ascSort = !column.ascSort;
            column.descSort = !column.descSort;
        }
        return column;
    }

    getAllResults() {
        const subscription$ = this.qvDashboardSearchService.getAllResults().subscribe((response: QVListResponse) => {
            this.myQVListResponse = response;
            this.placardsCount = this.myQVListResponse.placardsCount;
            //Emit to Parent view the total count of placards
            this.getMessageByStatus();
            this.supportPhoneNumber = this.myQVListResponse.supportPhoneNumber;
            if (response.placardsCount == 0) {
                this.isLoading = false;
            }
        });
        this.subscription.add(subscription$);
    }

    ngOnChanges() {
        const subscription$ = this.qvDashboardSearchService.subject.subscribe((data) => { // This occurs when refresh button is clicked in list view
            this.getAllResults();
        });
        this.subscription.add(subscription$);
    }

    onNavigate(value: any) {
        this.actionMenu.hide();
        window.open(value, "_blank");
    }

    showDetail(placardId: string) {
        this.closeHamMenu();
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }

    sendIdDetail(placardId: any) {
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }

    prepareLinksForTemporaryPlacard(placardID: string): Link[] {
        let results: Link[] = [];
        const countryCode = this.myQVListResponse.locations.find(x => x.placardId === placardID).address.countryCode;
        const temporaryPlacardURL = this.myQVListResponse.urlTemporary.replace("{placardID}", placardID);

        LANGUAGES_COUNTRIES_LOCALES.forEach(function (item) {
            if (item.countryCode === countryCode) {
                results.push(new Link(`${temporaryPlacardURL}?loc=${item.locale}`, `${this._translateData.transform('upplm.common.viewtemporaryplacard')} (${this._translateData.transform(item.language)})`));
            }
        }, this)

        return results;
    }

    getAddressForExportFile(address: any): string {
        let fixedAddress: string = '';
        if (this.validateStringValue(address.addressLine1)) {
            fixedAddress = fixedAddress.concat(address.addressLine1, ' ');
        }
        if (this.validateStringValue(address.addressLine2)) {
            fixedAddress = fixedAddress.concat(address.addressLine2, ' ');
        }
        if (this.validateStringValue(address.cityTown)) {
            fixedAddress = fixedAddress.concat(address.cityTown, ' ');
        }
        if (this.validateStringValue(address.stateProvince)) {
            fixedAddress = fixedAddress.concat(address.stateProvince, ' ');
        }
        if (this.validateStringValue(address.postalCode)) {
            fixedAddress = fixedAddress.concat(address.postalCode, ' ');
        }
        if (this.validateStringValue(address.countryCode)) {
            fixedAddress = fixedAddress.concat(address.countryCode, ' ');
        }
        return fixedAddress;
    }

    validateStringValue(value: string): boolean {
        if (!(value !== null ||
            (typeof value !== 'undefined' && value))) {
            return false;
        }
        return true;
    }

    // Hide Loading Spinner
    @ViewChildren('placardRow') row: QueryList<any>;
    ngAfterViewInit() {
        this.row.changes.subscribe(t => {
            this.isLoading = false;
        })
    }

    closeHamMenu() {
        const hamMenuElement = document.getElementsByClassName('ups-toggle_view_wrapper ups-toggle_view_container_popup ups-toggle_view_container_popup_sm ups-table_toggle_view ups-form_wrap');
        if (hamMenuElement[0]) {
            hamMenuElement[0].setAttribute('hidden', 'true');
        }
    }
}